import { render, staticRenderFns } from "./QandA.vue?vue&type=template&id=4ff241e6&"
import script from "./QandA.vue?vue&type=script&lang=js&"
export * from "./QandA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports